import { IconMoreVertical } from '@components/icons/more-vertical';

import type { ActionFn, OnRowClick } from './data-grid-types';

import { Menu } from '../menu';

export function DataGridActionMenu<T>({
  actions,
  onRowClick,
  data,
}: {
  actions: ActionFn<T>;
  onRowClick?: OnRowClick<T>;
  data: T;
}) {
  const computedActions = actions(data);
  if (!computedActions && !onRowClick) return null;

  return (
    <Menu
      buttonProps={{
        variant: 'ghost',
        iconLeft: <IconMoreVertical />,
        tabIndex: -1,
        isDisabled: computedActions?.length === 0 && !onRowClick,
      }}
    >
      {onRowClick && (
        <Menu.Item
          key="row-click"
          label={onRowClick.label}
          icon={onRowClick.icon}
          onSelect={() => onRowClick.callback(data)}
        />
      )}
      {(computedActions || []).map((action, index) => {
        if (action === 'separator') return <Menu.Separator key={index} />;
        return (
          <Menu.Item
            key={action.label}
            label={action.label}
            icon={action.icon}
            onSelect={() => action.onSelect(data)}
            variant={action.variant}
            isDisabled={action.isDisabled ? action.isDisabled(data) : false}
            tooltip={action.tooltip ? action.tooltip(data) : undefined}
          />
        );
      })}
    </Menu>
  );
}
